import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { SettingsService } from '../settings.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';
import { BaseService } from '../classes/BaseService';
import { ThemeService, ThemeMode } from '../theme.service';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
  providers: [ AuthenticationService ]
})
export class PreferencesComponent extends BaseComponent implements OnInit {

  @ViewChild("authentication", {static: false}) authentication;

  hidePurchasedItems: boolean;
  ignoreSdPriceOnWishlist: boolean;
  themeMode: ThemeMode;
  errorMessage = "";
  success = false;

  constructor(
    private settingsService: SettingsService,
    private themeService: ThemeService,
    private authService: AuthenticationService
  ) {
    super();
    this.themeMode = this.themeService.getThemeMode();
    this.themeService.applyTheme();
  }

  ngOnInit() {
    // Load ignoreSdPriceOnWishlist from localStorage (default: true)
    const storedIgnoreSdPrice = StorageHelper.getInstance().get(StorageHelper.keys.ignoreSdPriceOnWishlist);
    this.ignoreSdPriceOnWishlist = storedIgnoreSdPrice !== false;

    if(this.authService.isLoggedIn()) {
      this.settingsService.getHidePurchasedItems(
        StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
        Global.getCountry(),
        true
      ).subscribe(res => {
        this.hidePurchasedItems = res;
      }, err => {
        if (err === BaseService.COULDNT_LOAD_USER) {
          Global.clearSaveUserInfos();
          this.authentication.openLogin();
        }
        else {
          this.errorMessage = this.getString("settingsError");
        }
      });
    }
    else {
      setTimeout(() => {
        this.authentication.openLogin();
      });
    }
    
  }

  hidePurchasedItemsChanged(value) {
    this.hidePurchasedItems = value;
  }

  ignoreSdPriceOnWishlistChanged(value) {
    this.ignoreSdPriceOnWishlist = value;
    StorageHelper.getInstance().save(StorageHelper.keys.ignoreSdPriceOnWishlist, value);
  }

  themeModeChanged(mode: ThemeMode) {
    this.themeMode = mode;
    this.themeService.setThemeMode(mode);
  }

  ok() {

    this.settingsService.setHidePurchasedItems(
      Global.getCountry(),
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      this.hidePurchasedItems
      ).subscribe(res => {
        this.success = true;
      }, err => {
        this.errorMessage = this.getString("settingsError") + "\n" + err ? err : "";
      });

  }

}
